module.exports = __webpack_public_path__ + "assets/levels-mini.d70a29c3.svg";